import React, { useState, useEffect, useRef } from 'react';
import ReactLoading from 'react-loading';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
// import PropTypes from 'prop-types';
import { validateForm } from '../../selectors/defaultSelectors';
import { getTranslation } from '../../lang/main';
import FieldTextarea from '../fields/FieldTextarea';

const FORM_LABEL = {
    'Notes': getTranslation('FIELD.NOTES'),
    'Notes.Placeholder': getTranslation('FIELD.NOTES.PLACEHOLDER'),
};

function CartSummaryNoteForm(props) {
    const { notes, saveNotes, updateNotes, isSubmitting } = props;
    const [ isValidated, setIsValidated ] = useState(false);
    let fieldRefs = {};

    const handleFormUpdate = (e) => {
        updateNotes(e.target.value);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        saveNotes();
    };

    useEffect(() => {
        if(Object.values(fieldRefs).length > 0) {
            setIsValidated(!validateForm(fieldRefs));
        }
    }, [notes]);

    return (
        <React.Fragment>
            <form className="form" onSubmit={handleFormSubmit}>
                <FieldTextarea
                    ref={r => fieldRefs['Notes'] = r}
                    label={FORM_LABEL['Notes']}
                    animatedLabel={FORM_LABEL['Notes']}
                    name='__Notes'
                    value={notes || ''}
                    placeholder={FORM_LABEL['Notes.Placeholder']}
                    onChange={handleFormUpdate}
                />
                <footer>
                    <button type="submit" className={classnames('button button-submit form__submit', !isValidated && 'button--disabled')} disabled={!isValidated}>
                        <span style={{ opacity: isSubmitting ? 0 : 1 }}><LocalizedMessage id='SAVE' /></span>
                        {isSubmitting === true && <ReactLoading className="button__spinner" type="spin" color="white" height={20} width={20} />}
                    </button>
                    <button type="button" className="button button--border button-close" data-dismiss="modal"><LocalizedMessage id='CANCEL' /></button>
                </footer>
            </form>
        </React.Fragment>
    );
}

// default props
CartSummaryNoteForm.defaultProps = {
    // message: '',
};
// validate props
CartSummaryNoteForm.propTypes = {
    // message: PropTypes.string,
};

export default CartSummaryNoteForm;
